import { ReactNode } from "react";
import TabI from "../../TabI";
import { ThProps } from "../../../../components/TransactionPage/TransactionPage";
import { RowDataTransaction } from "../../../../components/TransactionPage/types";

abstract class TransactionTab implements TabI {
    sortBy: keyof RowDataTransaction | null
    setSorting: { (field: keyof RowDataTransaction): void }
    Th: { ({ children, sortable, reversed, sorted, onSort }: ThProps): JSX.Element }
    rowDataTransaction: RowDataTransaction[] | null

    constructor(sortBy: keyof RowDataTransaction | null, setSorting: { (field: keyof RowDataTransaction): void }, Th: { ({ children, sortable, reversed, sorted, onSort }: ThProps): JSX.Element }, rowDataTransaction: RowDataTransaction[] | null) {
        this.sortBy = sortBy
        this.setSorting = setSorting
        this.Th = Th
        this.rowDataTransaction = rowDataTransaction
    }

    abstract create(reverseSortDirection: boolean, classes: { readonly [key: string]: string }, rows: JSX.Element[]): ReactNode
}

export default TransactionTab